const _componentSelect2 = function($context) {
    if (!$().select2) {
        console.warn('Warning - select2.min.js is not loaded.');
        return;
    }
    
    $context = $context instanceof jQuery ? $context : $(document);
    
    const $selectSearchArticles = $context.find('.js-ci-select-remote-search-articles');    
    const $selectSearchDictionariesBrands = $context.find('.js-ci-select-remote-search-dictionaries-brands');
    const $selectSearchDictionariesParams = $context.find('.js-ci-select-remote-search-dictionaries-params');
    const $selectSearchCategories = $context.find('.js-ci-select-remote-search-categories');
    const $selectSearchUsers = $context.find('.js-ci-select-remote-search-users');
    
    // icube - wyszukiwarka artykułów
    if ($selectSearchArticles.length) {
        import(MODULES_PATH + 'panel/create-select-with-search').then(({ createSelectWithSearch }) => {
            createSelectWithSearch($selectSearchArticles, {
                url: '/client/cms/articles/search',
                searchFormat: function(article) {
                    if (!article.article_id) { 
                        return article.text; 
                    }
                    
                    return '<div class="select2-result-repository clearfix js-template">' +
                                '<div class="select2-result-repository__title">' + article.article_title + '</div>'+
                                '<div class="select2-result-repository__description">#: '+article.article_id+(article.author_name !== '' ? ' - Autor: '+article.author_name : '')+(article.route.url !== '' ? ' - URL: '+article.route.url : '')+'</div>'+
                            '</div>';
                },
                searchFormatSelection: function(article) {
                    return article.article_title || article.text;
                }
            });
        });
    }
    
    // icube - wyszukiwarka marek
    if ($selectSearchDictionariesBrands.length) {
        import(MODULES_PATH + 'panel/create-select-with-search').then(({ createSelectWithSearch }) => {
            createSelectWithSearch($selectSearchDictionariesBrands, {
                url: '/client/dictionaries/brands/search',
                searchFormat: function(b) {
                    if (!b.brand_id) { 
                        return b.text; 
                    }
                    
                    return '<span class="js-template">'+(b.brand_icon ? '<img src="' + $(b.brand_icon) + '" style="max-width: 40px; max-height: 40px;" /> ' : '') + b.brand_name + (b.brand_slogan ? ' ('+b.brand_slogan+')' : '') + '</span>';
                },
                searchFormatSelection: function(b) {
                    return b.brand_name || b.text;
                }
            });
        });
    }
    
    // icube - wyszukiwarka parametrów       
    if ($selectSearchDictionariesParams.length) {
        import(MODULES_PATH + 'panel/create-select-with-search').then(({ createSelectWithSearch }) => {
            createSelectWithSearch($selectSearchDictionariesParams, {
                url: '/client/dictionaries/params/search',
                searchFormat: function(p) {
                    if (!p.param_id) { return p.text; }
                    return '<div class="select2-result-repository clearfix">' +
                        '<div class="select2-result-repository__title"><b>' + p.param_name + '</b></div>'+
                        (p.param_description ? '<div class="select2-result-repository__title">'+p.param_description+'</div>' : '')+
                        '<div class="select2-result-repository__description">#'+p.param_id+' - Typ: '+p.param_type+(p.param_unit ? ' - Jednostka: '+p.param_unit+'</div>' : '')+
                        '</div>';
                },
                searchFormatSelection: function(p) {
                    return p.param_name || p.text;
                }
            });
        });
    }    
  
    // icube - wyszukiwarka kategorii
    if ($selectSearchCategories.length) {
        import(MODULES_PATH + 'panel/create-select-with-search').then(({ createSelectWithSearch }) => {
            function searchFormatSelection(c) {
                return c.category_name || c.text;
            }

            function fullPathFormatSelection(c) {
                return c.flatten_category_path || c.text;
            }

            createSelectWithSearch($selectSearchCategories, {
                beforeInit: function($el, config) {
                    config.url = $el.data('url') ? $el.data('url') : '/client/'+ $el.data('package') +'/categories/search';
                    config.searchFormatSelection = $el.data('fullpath') ? fullPathFormatSelection : searchFormatSelection;  
                },
                url: '/client/dictionaries/params/search',
                perPage: 5,
                data: function (params) {
                    return {
                        q: params.term, // search term
                        page: params.page,
                        excludeid: $(this).data('excludeid'),
                        leaves: $(this).data('leaves'),
                        mode: $(this).data('mode')
                    };
                },
                searchFormat: function(c) {
                    if (!c.category_id) { return c.text; }
                    return '<div class="select2-result-repository clearfix">' +
                        '<div class="select2-result-repository__title"><b>' + c.category_name + '</b></div>'+
                        '<div class="select2-result-repository__description">'+c.flatten_category_path+' (ID: '+c.category_id+')</div>'+
                        '</div>';
                }
            });
        });
    }    
    
    // icube - wyszukiwarka użytkowników
    if ($selectSearchUsers.length) { 
        import(MODULES_PATH + 'panel/create-select-with-search').then(({ createSelectWithSearch }) => {
            function searchFormatSelection(u) {
                var $self = this;
                var autocompleteFields = [];
                var prefix = '';
                var $form;  
                
                if ($self.data('autocomplete-prefix') && u.selected === false) {
                    prefix = $self.data('autocomplete-prefix') + '_';
                    autocompleteFields = [
                        'company_name', 'first_name', 'last_name', 'nip', 'address', 'address_number', 'city_name', 'region_name',
                        'country_name', 'zip_name'
                    ];
                    $form = $self.closest('form');

                    $.each(autocompleteFields, function(index, fieldName) {
                        if ((fieldName === 'company_name' || fieldName === 'nip') && u.account_type === 1) return;
                        if ((fieldName === 'first_name' || fieldName === 'last_name') && u.account_type === 2) return;
                        
                        $form.find('[name="' + prefix + fieldName + '"]').val(u[fieldName]).trigger('change');
                    });
                }
                
                if (u.account_type === 2) {
                    return u.company_name || u.text;
                } else if (u.account_type === 1) {
                    return u.first_name+' '+u.last_name + ' (ID: '+u.credential_id+')';
                }

                return u.text;
            }

            createSelectWithSearch($selectSearchUsers, {
                beforeInit: function($el, config) {
                    config.searchFormatSelection = searchFormatSelection.bind($el);
                },
                url: '/client/users/accounts/search',
                perPage: 5,
                searchFormat: function(u) {
                    if (!u.credential_id) { 
                        return u.text; 
                    }
                    
                    if (u.account_type === 2) {
                        return '<div class="select2-result-repository clearfix">' +
                        '<div class="select2-result-repository__title"><b>' + u.company_name + '</b></div>'+
                        '<div class="select2-result-repository__description">USt-IdNr.: '+u.nip+' (ID: '+u.credential_id+')</div>'+
                        '</div>';
                    }
                    
                    return '<div class="select2-result-repository clearfix">' +
                        '<div class="select2-result-repository__title"><b>' + u.first_name + ' ' + u.last_name + '</b></div>'+
                        '<div class="select2-result-repository__description">ID: '+u.credential_id+'</div>'+
                        '</div>';
                }
            });
        }); 
    }
};

function init($context) {           
    _componentSelect2($context);
}

export const Search = {
    init
}